<ng-container [ngSwitch]="settings?.type">
    <ng-container *ngSwitchCase="menuTypes.button">
        <datiq-button
            class="datiq-menu__trigger datiq-menu__button"
            [settings]="settings?.button"
            [matMenuTriggerFor]="menu"
        ></datiq-button>
    </ng-container>
    <ng-container *ngSwitchDefault>
        <ng-container *ngIf="!settings?.disabled; else disabledTemplate">
            <button
                mat-icon-button
                class="datiq-menu__trigger datiq-menu__trigger--default"
                [attr.data-testid]="settings?.button?.id ?? settings?.id"
                (click)="$event.stopPropagation(); clickTrigger()"
                [matMenuTriggerFor]="menu"
            >
                <mat-icon [svgIcon]="settings?.icon"></mat-icon>
            </button>
        </ng-container>
        <ng-template #disabledTemplate>
            <button
                mat-icon-button
                class="datiq-menu__trigger datiq-menu__trigger--default datiq-menu__trigger--disabled"
                [attr.data-testid]="settings?.button?.id ?? settings?.id"
                [disabled]="settings?.disabled"
            >
                <mat-icon [svgIcon]="settings?.icon"></mat-icon>
            </button>
        </ng-template>
    </ng-container>
</ng-container>
<mat-menu class="datiq-menu {{ settings?.menuClass }}" #menu="matMenu">
    <ng-container *ngFor="let item of settings?.items">
        <button
            (click)="clickedMenuItem(item)"
            class="datiq-menu__item"
            [ngClass]="{
                'datiq-menu__item--disabled': item?.disabled,
                'datiq-menu__item--header': item?.menuHeader
            }"
            [disabled]="item?.disabled"
            [attr.data-testid]="item?.id"
            mat-menu-item
        >
            <div class="flex items-center">
                <ng-container *ngIf="!!item.icon">
                    <mat-icon
                        [svgIcon]="item.icon"
                        class="datiq-icon datiq-menu__item__icon"
                    ></mat-icon>
                </ng-container>
                <span
                    class="datiq-label datiq-menu__item__label"
                    [ngClass]="{
                        flex: item?.showTooltip,
                        'justify-between': item?.showTooltip,
                        'items-center': item?.showTooltip
                    }"
                >
                    {{ item.label }}
                    <ng-container *ngIf="item.showTooltip">
                        <datiq-tooltip
                            [triggerIconSize]="24"
                            [settings]="item.tooltip"
                        ></datiq-tooltip>
                    </ng-container>
                </span>
            </div>
        </button>
    </ng-container>
</mat-menu>
